import type { ComponentProps } from "react";

import { cn } from "@/lib/helpers/cn";
import ExternalIcon from "@/assets/images/icons2/icon--external-link.svg";

type LinkProps = {
  isExternal?: boolean;
} & ComponentProps<"a">;

export function Link2({ children, className, isExternal, ...linkProps }: LinkProps) {
  return (
    <a
      className={cn(
        "tw:text-text-teal-primary!",
        !linkProps.href && "tw:cursor-pointer",
        className,
      )}
      {...(isExternal && { rel: "noopener noreferrer", target: "_blank" })}
      {...linkProps}
    >
      {children}
      {isExternal && <img alt="" className="tw:ml-2 tw:align-text-top!" src={ExternalIcon} />}
    </a>
  );
}
